// src/services/LabTestApi/packageService.js
import axios from "axios";

const BASE_URL = (process.env.REACT_APP_API_URL || 'https://admintest.medrphalabs.com/api').replace(/\/+$/, '');

export const getAllPackages = async () => {
  try {
    const url = `${BASE_URL}/Package`;
    console.log('📌 Fetching from:', url);
    
    const res = await axios.get(url, {
      headers: { 'accept': '*/*', 'Content-Type': 'application/json' }
    });

    if (!Array.isArray(res.data)) return [];

    // ✅ Sirf active packages (isActive === true)
    const activePackages = res.data.filter(pkg => 
      pkg.isActive === true || pkg.isActive === "true"
    );
    
    console.log(`📌 Total: ${res.data.length}, Active: ${activePackages.length}`);
    return activePackages;

  } catch (error) {
    console.error("❌ Package API Error:", error);
    return [];
  }
};

export const getPackagesByLabId = async (labId) => {
  try {
    // Agar labId undefined/null/0 hai toh saare active packages return karo
    if (!labId || Number(labId) === 0) {
      console.warn('⚠️ labId is invalid, returning all active packages');
      return await getAllPackages();
    }
    
    const allPackages = await getAllPackages();
    const filtered = allPackages.filter(pkg => 
      Number(pkg.labId) === Number(labId)
    );
    
    console.log(`📌 Lab ${labId}: ${filtered.length} packages`);
    return filtered;
    
  } catch (error) {
    console.error('❌ Error:', error);
    return [];
  }
};